// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tariffs-page {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.tariffs-page .page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.tariffs-page .page-header h1 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}

.tariffs-page .btn-primary {
  padding: 0.6rem 1.2rem;
  background: var(--button-color, #007bff);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
}

.tariffs-page .btn-primary:hover {
  opacity: 0.9;
}

.tariffs-page .error-message {
  background: #fee;
  color: #c00;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.tariffs-table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.tariffs-table {
  width: 100%;
  border-collapse: collapse;
}

.tariffs-table th,
.tariffs-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.tariffs-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #555;
  font-size: 0.85rem;
  text-transform: uppercase;
}

.tariffs-table tbody tr:hover {
  background: #f8f9fa;
}

.tariffs-table .tariff-name {
  font-weight: 500;
}

.tariffs-table .tariff-description {
  color: #666;
  font-size: 0.9rem;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tariffs-table .status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 500;
}

.tariffs-table .status-badge.active {
  background: #d4edda;
  color: #155724;
}

.tariffs-table .status-badge.inactive {
  background: #f8d7da;
  color: #721c24;
}

.tariffs-table .actions {
  white-space: nowrap;
}

.tariffs-table .btn-edit {
  padding: 0.4rem 0.8rem;
  background: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
}

.tariffs-table .btn-edit:hover {
  background: #e0e0e0;
}

.tariffs-table .empty-message {
  text-align: center;
  color: #888;
  padding: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/TariffsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf","sourcesContent":[".tariffs-page {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.tariffs-page .page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.tariffs-page .page-header h1 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #333;\n}\n\n.tariffs-page .btn-primary {\n  padding: 0.6rem 1.2rem;\n  background: var(--button-color, #007bff);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.tariffs-page .btn-primary:hover {\n  opacity: 0.9;\n}\n\n.tariffs-page .error-message {\n  background: #fee;\n  color: #c00;\n  padding: 1rem;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n}\n\n.tariffs-table-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.tariffs-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.tariffs-table th,\n.tariffs-table td {\n  padding: 1rem;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.tariffs-table th {\n  background: #f8f9fa;\n  font-weight: 600;\n  color: #555;\n  font-size: 0.85rem;\n  text-transform: uppercase;\n}\n\n.tariffs-table tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.tariffs-table .tariff-name {\n  font-weight: 500;\n}\n\n.tariffs-table .tariff-description {\n  color: #666;\n  font-size: 0.9rem;\n  max-width: 300px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.tariffs-table .status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.tariffs-table .status-badge.active {\n  background: #d4edda;\n  color: #155724;\n}\n\n.tariffs-table .status-badge.inactive {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.tariffs-table .actions {\n  white-space: nowrap;\n}\n\n.tariffs-table .btn-edit {\n  padding: 0.4rem 0.8rem;\n  background: #f0f0f0;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.85rem;\n}\n\n.tariffs-table .btn-edit:hover {\n  background: #e0e0e0;\n}\n\n.tariffs-table .empty-message {\n  text-align: center;\n  color: #888;\n  padding: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
